import MySurveys from "views/MySurveys";
import Questions from "views/Questions";
import CreateSurvey from "views/CreateSurvey";
import Settings from "views/Settings";
import Support from "views/Support";
import MyReports from "views/MyReports";
import BuildReport from "views/BuildReport";
import PreBuildReport from "views/PreBuildReport";
import PlayAudio from "views/PlayAudio";
import MyShowreels from "views/MyShowreels";
import CreateShowreel from "views/CreateShowreel";
import CreatePanelRequest from "views/CreatePanelRequest";
import MyPanelRequests from "views/MyPanelRequests";
import MyPeople from "views/MyPeople";
import Person from "views/Person";
import Files from "views/Files";
import Home from "views/Home";
import Plans from "views/Plans";

import {
  faChartPie,
  faCog,
  faCommentAlt,
  faFolderOpen,
  faHome,
  faPlayCircle,
  faScroll,
  faUserFriends,
} from "@fortawesome/free-solid-svg-icons";

import { SHOW_SAAS_UI_ELEMENTS } from "./utils/featureFlags";

const dashboardRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: faHome,
    component: Home,
    showInNav: false,
  },
  {
    path: "/surveys",
    name: "Surveys",
    icon: faScroll,
    component: MySurveys,
    showInNav: true,
    authenticated: true,
  },
  {
    path: "/surveys/create",
    name: "Create",
    icon: faScroll,
    component: CreateSurvey,
    showInNav: false,
  },
  {
    path: "/surveys/:surveyId/create",
    name: "Create Survey",
    component: CreateSurvey,
    showInNav: false,
  },
  {
    path: "/create_survey/:surveyId",
    name: "Create Survey",
    component: CreateSurvey,
    showInNav: false,
  },
  {
    path: "/surveys/:surveyId/respondents/:sessionObjectId",
    name: "Questions",
    component: Questions,
  },
  {
    path: "/surveys/:surveyId/:tab",
    name: "Questions",
    component: Questions,
  },
  {
    path: "/surveys/:surveyId",
    name: "Questions",
    component: Questions,
  },
  {
    path: "/surveys/:surveyId/questions/:questionId",
    name: "Question",
    component: Questions,
  },
  {
    path: "/surveys/:surveyId/questions/:questionId/responses/:responseId",
    name: "Play",
    component: PlayAudio,
    showInNav: false,
    authenticated: false,
  },
  {
    path: "/files",
    name: "Files",
    icon: faFolderOpen,
    component: Files,
    showInNav: SHOW_SAAS_UI_ELEMENTS,
  },
  {
    path: "/files/:path+" /* The + indicates path can contain forward slashes */,
    name: "Files",
    component: Files,
    showInNav: false,
    matchNonExactly: true,
  },
  {
    path: "/reports",
    name: "Reports",
    icon: faChartPie,
    component: MyReports,
    showInNav: true,
    authenticated: true,
  },
  {
    path: "/showreels",
    name: "Reels",
    icon: faPlayCircle,
    component: MyShowreels,
    showInNav: true,
  },
  {
    path: "/showreels/create",
    name: "Create Showreel",
    component: CreateShowreel,
    showInNav: false,
  },
  {
    path: "/showreels/:showreelId/create",
    name: "Create Showreel",
    component: CreateShowreel,
    showInNav: false,
  },
  {
    path: "/create_showreel/:showreelId",
    name: "Create Showreel",
    component: CreateShowreel,
    showInNav: false,
  },
  {
    path: "/recruit_DEPRECATED",
    name: "Recruit",
    icon: faUserFriends,
    component: MyPanelRequests,
  },
  {
    path: "/recruit/create",
    name: "Recruit",
    icon: faUserFriends,
    component: CreatePanelRequest,
  },
  {
    path: "/recruit/:panelRequestId/create",
    name: "Recruit",
    icon: faUserFriends,
    component: CreatePanelRequest,
  },
  {
    path: "/people",
    name: "People",
    icon: faUserFriends,
    component: MyPeople,
    showInNav: false,
  },
  {
    path: "/people/:personId",
    name: "Person",
    component: Person,
    showInNav: false,
  },
  {
    path: "/settings",
    name: "Settings",
    icon: faCog,
    component: Settings,
    showInNav: true,
  },
  {
    path: "/support",
    name: "Support",
    icon: faCommentAlt,
    component: Support,
    showInNav: false,
  },
  {
    path: "/play/:responseId",
    name: "Play",
    component: PlayAudio,
    showInNav: false,
    authenticated: false,
  },
  {
    path: "/reports/:reportId/create",
    name: "Report Builder",
    component: BuildReport,
    showInNav: false,
  },
  {
    path: "/reports_create",
    name: "New Report",
    component: PreBuildReport,
    showInNav: false,
  },
  {
    path: "/plans",
    name: "Plans",
    component: Plans,
    showInNav: false,
    authenticated: false,
  },
];

export default dashboardRoutes;
